<template>
    <div>
        <fr-list-group :title="'Le mie applicazioni'">
            <fr-list-item :collapsible="true">
                <div slot="list-item-header" class="d-inline-flex w-100 media">
                    <div class="media-body align-self-center">
                        <h6>Applicazioni per le quali l'utente è abilitato</h6>
                    </div>
                    <div class="btn btn-sm btn-link float-right btn-edit"> Visualizza </div>
                </div>
                <div slot="list-item-collapse-body" class="d-inline-flex w-50">
                    <b-row>
                        <b-col>
                            <label> Seleziona un'applicazione tra quelle disponibili </label>
                            <br />
                            <div class="form-group row">
                                <div class="col-sm-10">
                                    <div class="d-flex">
                                        <b-form-select v-model="selected" :options="availableApps" class="mb-3 mr-2"  style="width:900px;" />
                                        <b-button type="button" variant="primary" class="mb-3 d-flex align-self-end" @click="visitPage" :disabled="selected === null"> Vai </b-button>
                                    </div>
                                </div>
                                <b-button type="button" variant="primary" class="mb-3 d-flex align-self-end" @click="refreshList" style="visibility: hidden;"> Aggiorna Lista </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </fr-list-item>
        </fr-list-group>
        <br />
        <Processes :processes="processes" ref="processes" @startProcess="startProcess" @loadProcess="loadProcessDefinition"></Processes>
        <MyTasks :tasks="assignedTasks" @updateAssignment="updateAssignment" @completeTask="completeTask" @loadProcess="loadProcessDefinition"></MyTasks>
        <GroupTasks :tasks="availableTasks" @updateAssignment="updateAssignment" @loadProcess="loadProcessDefinition"></GroupTasks>
    </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import $ from 'jquery';
import GroupTasks from '@/components/dashboard/widgets/workflow/GroupTasks';
import MyTasks from '@/components/dashboard/widgets/workflow/MyTasks';
import Processes from '@/components/dashboard/widgets/workflow/Processes';
import ListGroup from '@/components/utils/ListGroup';
import ListItem from '@/components/utils/ListItem';

/**
 * @description Controlling file for loading the three different parts of workflow (available tasks, available processes, and tasks assigned to you).
 *
 * @fires POST /workflow/taskinstance/ID?_action=complete - Call used to save a task, the expected data is based on the configured workflow
 * @fires PUT  /workflow/taskinstance/ID - Assigns a user to an already created task, expected input is a assignee ID
 * @fires GET /endpoint/gettasksview - Get task view information (based on workflow configuration)
 * @fires POST  /workflow/processinstance/?_action=create - Create or start a new task (based on how workflow is configured)
 * @fires GET  /endpoint/getprocessesforuser- Returns all the current task instances assigned to the user currently logged in
 * @fires GET /workflow/processdefinition/ID - Gets the details for the process definition (based on workflow configuration)
 *
 **/
export default {
    name: 'Workflow-Control-Widget',
    components: {
        MyTasks,
        GroupTasks,
        Processes,
        'fr-list-item': ListItem,
        'fr-list-group': ListGroup
    },
    props: ['userDetails', 'widgetDetails'],
    data () {
        return {
            workflowService: null,
            assignedTasks: {},
            availableTasks: {},
            processes: {},
            selected: null,
            availableApps: []
        };
    },
    created () {
        this.workflowService = this.getRequestService();
        let url = $(location).attr('href'), UID = '', assignedRoles = [], self = this;
        url = url.substring(0, url.indexOf('#') - 1) + self.getRequestService().defaults.baseURL;
        $.ajax({
            type: 'GET',
            async: false,
            url: url + '/info/login',
            success: function (data) {
                UID = data.authorization.id;
            }
        });
        $.ajax({
            type: 'GET',
            async: false,
            url: url + '/managed/user/' + UID,
            success: function (data) {
                $.each(data.effectiveRoles, function (index, role) {
                    assignedRoles.push(role._ref.substring(role._ref.lastIndexOf('/') + 1));
                });
            }
        });
        $.each(assignedRoles, function (index, role) {
            function singleRequest () {
                $.ajax({
                    type: 'GET',
                    async: false,
                    url: url + '/managed/role/' + role,
                    success: function (data) {
                        if (!self.availableApps.some(e => e.text.substring(0, e.text.indexOf('-') - 1) === data.name.substring(data.name.indexOf('-') + 1).toUpperCase())) {
                            self.availableApps.push({
                                text: data.name.substring(data.name.indexOf('-') + 1).toUpperCase() + ' - ' + (data.descrizioneApp ? data.descrizioneApp : data.name.substring(data.name.indexOf('-') + 1).toUpperCase()),
                                value: data.URL
                            });
                        }
                    },
                    error: function () {
                        setTimeout(() => {
                            singleRequest();
                        }, 200);
                    }
                });
            }
            singleRequest();
        });
        this.loadData();
    },
    methods: {
        visitPage () {
            window.open(this.selected, '_blank');
        },
        refreshList () {
            this.selected = null;
            this.availableApps = [];
            let url = $(location).attr('href'), UID = '', assignedRoles = [], self = this;
            url = url.substring(0, url.indexOf('#') - 1) + self.getRequestService().defaults.baseURL;
            $.ajax({
                type: 'GET',
                async: false,
                url: url + '/info/login',
                success: function (data) {
                    UID = data.authorization.id;
                }
            });
            $.ajax({
                type: 'GET',
                async: false,
                url: url + '/managed/user/' + UID,
                success: function (data) {
                    $.each(data.effectiveRoles, function (index, role) {
                        assignedRoles.push(role._ref.substring(role._ref.lastIndexOf('/') + 1));
                    });
                }
            });
            $.each(assignedRoles, function (index, role) {
                $.ajax({
                    type: 'GET',
                    async: false,
                    url: url + '/managed/role/' + role,
                    success: function (data) {
                        self.availableApps.push({
                            text: data.name.substring(data.name.indexOf('-') + 1).toUpperCase() + ' - ' + (data.descrizioneApp ? data.descrizioneApp : data.name.substring(data.name.indexOf('-') + 1).toUpperCase()),
                            value: data.URL
                        });
                    }
                });
            });
        },
        completeTask ({ id, formData }) {
            /* istanbul ignore next */
            return this.workflowService.post(`/workflow/taskinstance/${id}?_action=complete`, formData, {
                headers: { 'Accept': 'application/json, text/javascript, */*; q=0.01' }
            })
                .then((response) => {
                    this.displayNotification('success', this.$t('pages.workflow.taskSuccessfullyCompleted'));
                    this.$delete(this.assignedTasks, id);
                })
                .then(this.loadData)
                .catch((error) => {
                    if (error.response.data.code === 403) {
                        this.displayNotification('error', this.$t('pages.workflow.taskNoLongerAvailable', { taskName: this.assignedTasks[id].name }));
                        this.$delete(this.assignedTasks, id);
                        this.loadTasks();
                    } else {
                        this.displayNotification('error', error.response.data.message);
                    }
                });
        },
        updateAssignment ({ id, task, assignee }) {
            /* istanbul ignore next */
            return this.workflowService.put(`/workflow/taskinstance/${task._id}`, { assignee }, { headers: { 'If-Match': '"*"' } })
                .then((response) => {
                    if (assignee === null) {
                        this.displayNotification('success', 'Assegnazione correttamente rimossa');
                    } else {
                        this.displayNotification('success', this.$t('pages.workflow.assignmentSuccess', { taskName: task.name, assignee }));
                    }
                    // Use $delete to remove the task from the list to get the proper transition
                    this.$delete(this.assignedTasks, id);
                    this.$delete(this.availableTasks, id);
                })
                .then(this.loadData)
                .catch((error) => {
                    if (error.response.data.code === 403) {
                        this.displayNotification('error', this.$t('pages.workflow.taskNoLongerAvailable', { taskName: this.availableTasks[id].name }));
                        this.$delete(this.availableTasks, id);
                        this.loadTasks();
                    } else {
                        this.displayNotification('error', error.response.data.message);
                    }
                });
        },
        startProcess (payload) {
            /* istanbul ignore next */
            return this.workflowService.post('/workflow/processinstance/?_action=create', payload)
                .then((response) => {
                    this.displayNotification('success', this.$t('pages.workflow.processStartSuccessMessage'));
                    this.$refs.processes.cancel(payload._processDefinitionId);
                })
                .then(this.loadData)
                .catch((error) => {
                    this.displayNotification('error', error.response.data.message);
                });
        },
        loadProcessDefinition (process) {
            /* istanbul ignore next */
            process.fetchProcessDefinition()
                .then(({ data }) => {
                    this.$set(process, 'processDefinition', data);
                })
                .catch((error) => {
                    this.displayNotification('error', error.reponse.data.message);
                });
        },
        loadProcesses () {
            /* istanbul ignore next */
            return this.workflowService.get('/endpoint/getprocessesforuser')
            // Grab the array of processes off the response object.
                .then((processes) => processes.data.processes)
            // Get the process definition for each process object
                .then((processes) => {
                    return axios.all(processes.map((process) => {
                        let fetchProcessDefinition = () => this.workflowService.get(`/workflow/processdefinition/${process._id}`),
                            processDefinition = null;
                        return _.merge(process, { fetchProcessDefinition, processDefinition });
                    }));
                })
            // Use the built in `$set` function to reactively get the process definitions into component state
                .then((processDefinitions) => {
                    processDefinitions.forEach((definition) => {
                        this.$set(this.processes, definition._id, definition);
                    });
                });
        },
        getTaskParams (userId, groupName) {
            const params = {
                _queryId: 'gettasksview',
                userId
            };

            if (groupName === 'assignedTasks') {
                params.viewType = 'assignee';
            }

            return params;
        },
        getTaskGroup (groupName) {
            return this[groupName];
        },
        toTasks (taskGroup, { data }) {
            // Filter out any empty results
            let [ tasks ] = _.reject(data.result, _.isEmpty);

            // Process each result
            _.each(tasks, (taskObj, id) => {
                let name = taskObj.name,
                    task = _.first(taskObj.tasks),
                    process = this.processes[task.processDefinitionId],
                    fetchProcessDefinition = () => {
                        return this.workflowService.get(`/workflow/processdefinition/${task.processDefinitionId}`);
                    };

                if (_.isUndefined(process)) {
                    process = { fetchProcessDefinition };
                }

                // Use $set to maintain reactivity
                this.$set(taskGroup, id, { name, task, process });
            });
        },
        loadTasks (options = { groupName: 'availableTasks' }) {
            /* istanbul ignore next */
            return this.workflowService.get('/endpoint/gettasksview', {
                params: this.getTaskParams(this.userDetails.userId, options.groupName)
            }).then((response) => {
                this.toTasks(this.getTaskGroup(options.groupName), response);
            });
        },
        loadData () {
            /* istanbul ignore next */
            this.loadProcesses() // Need to load processes first so process definitions are available to tasks when loaded
                .then(() => axios.all([this.loadTasks({ groupName: 'assignedTasks' }), this.loadTasks({ groupName: 'availableTasks' })]))
                .catch((error) => {
                    this.displayNotification('error', error.response.data.message);
                });
        }
    }
};
</script>

<style lang="scss" scoped></style>
